import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-efaa320e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inputsBox" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "mastercardIcon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#mastercard-icon--sprite" })
], -1))
const _hoisted_3 = { class: "sumBox" }
const _hoisted_4 = { class: "sumInputBox" }
const _hoisted_5 = {
  key: 0,
  class: "sumInfo"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "i" }, "=", -1))
const _hoisted_7 = { class: "i" }
const _hoisted_8 = { class: "feeInfo" }
const _hoisted_9 = { class: "i" }
const _hoisted_10 = { class: "button" }
const _hoisted_11 = {
  key: 0,
  class: "infoBlock"
}
const _hoisted_12 = {
  key: 1,
  class: "infoBlock"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonTabs = _resolveComponent("CommonTabs")!
  const _component_CommonInput = _resolveComponent("CommonInput")!
  const _component_CommonButtonPrimary = _resolveComponent("CommonButtonPrimary")!
  const _component_CommonModal = _resolveComponent("CommonModal")!

  return (_openBlock(), _createBlock(_component_CommonModal, {
    name: _ctx.modalName,
    title: _ctx.$t('Withdraw from {currency} balance', { currency: 'BTC' })
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
      }, [
        _createVNode(_component_CommonTabs, {
          currentTab: _ctx.data.tab,
          tabs: _ctx.tabsList,
          onClick: _ctx.changeTab
        }, null, 8, ["currentTab", "tabs", "onClick"]),
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forms[_ctx.data.tab], (input) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(['inputItem', input.addClass]),
              key: input.name
            }, [
              _createVNode(_component_CommonInput, _mergeProps(input, {
                modelValue: _ctx.data[input.name],
                "onUpdate:modelValue": ($event: any) => (_ctx.onChange(input.name, $event)),
                inputSuffixClass: _ctx.data.tab === 'card' ? 'suffClass' : '',
                required: ""
              }), _createSlots({
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(input.label)) + " ", 1)
                ]),
                _: 2
              }, [
                (_ctx.data.tab === 'card')
                  ? {
                      name: "suffix",
                      fn: _withCtx(() => [
                        _hoisted_2
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1040, ["modelValue", "onUpdate:modelValue", "inputSuffixClass"])
            ], 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_CommonInput, {
              modelValue: _ctx.data.sum || '',
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange('sum', $event))),
              required: "",
              mask: "#.#*",
              hasError: !_ctx.isSumVaid
            }, {
              suffix: _withCtx(() => [
                _createTextVNode("BTC")
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Sum")) + " ", 1)
              ]),
              _: 1
            }, 8, ["modelValue", "hasError"])
          ]),
          (_ctx.ratesState === 'FULFILLED')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(_toDisplayString(_ctx.sumInEur) + " $", 1),
                _createElementVNode("span", _hoisted_7, "1 BTC = " + _toDisplayString(_ctx.oneBtcInEur) + " $", 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("span", { class: "feeText" }, _toDisplayString(_ctx.$t("{sum} fee", { sum: _ctx.fee || 0 })), 513), [
            [_vShow, _ctx.data.tab !== 'paystree']
          ]),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.commission[_ctx.data.tab].label), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_CommonButtonPrimary, {
            type: "submit",
            disabled: !_ctx.isSumVaid || !_ctx.formIsValid
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Withdraw")) + " " + _toDisplayString(_ctx.isSumVaid ? _ctx.sumWithFee.format() : 0) + " BTC ", 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        (_ctx.data.tab === 'btc')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t("Withdrawal is carried out within three days.")), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t("Withdrawal is carried out within 14 days")) + ". ", 1))
      ], 32)
    ]),
    _: 1
  }, 8, ["name", "title"]))
}